module.exports = __webpack_public_path__ + "img/27_14.e415431a.png";